// extracted by mini-css-extract-plugin
export var followSocialsWrapper = "styles-module--followSocialsWrapper--8NXgc";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var shareLinks = "styles-module--shareLinks--qQDRm";